var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEnterOrReturn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.65 4a.75.75 0 0 1 .75-.75H12c.966 0 1.75.784 1.75 1.75v4A1.75 1.75 0 0 1 12 10.75H4.101l1.475 1.77a.75.75 0 1 1-1.152.96l-2.5-3a.75.75 0 0 1 0-.96l2.5-3a.75.75 0 0 1 1.152.96L4.101 9.25H12a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25H9.4A.75.75 0 0 1 8.65 4z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEnterOrReturn);
export default ForwardRef;